// common/api.js

const api = {
  //oss域名配置
  ossurl : "https://art-compass.oss-cn-beijing.aliyuncs.com/art_pc",
	// 获取文章列表
	getArticleList: 'api/Article/getArticleList',
	// 获取全部省份
	getCommonProvList: 'api/Common/getCommonProvList',
	// 发送阿里云短信验证码
	sendVerifyCode: 'api/Login/sendVerifyCode',
	// 短信验证码登录
	verifyCodeLogin: 'api/Login/verifyCodeLogin',
	// 修改密码
	editPassword: 'api/Login/editPassword',
	// 获取用户信息
	getUserInfo: 'api/Common/getUserInfo',
	// 首页获取推荐数量
	// getHomeExamCount: 'api/Exam/getHomeExamCount',
	getHomeExamCount: 'api/Exam/getHomeExamCountNew',
	// 获取方案推荐列表数量
	// getExamListCount: 'api/Exam/getExamListCount',
	getExamListCount: 'api/Exam/getExamListCountNew',
	// 获取方案推荐列表
	// getExamList: 'api/Exam/getExamList',
	getExamList: 'api/Exam/getExamListNew',
	// 获取学校列表
	getSchoolList: 'api/School/getSchoolList',
	// 首页搜索
	commonSearch: 'api/Common/commonSearch',
	// 获取专业列表
	getProfessionList: 'api/Profession/getProfessionList',
	// 首页快讯
	getHomeMsg: 'api/HomePage/getHomeMsg',
	// 时间轴
	getTimeAxis: 'api/HomePage/getTimeAxis',
	//问题反馈
	addRecommend: 'api/Tools/addRecommend',
	//获取省份接口
	getProvList: 'api/Common/getProvList',
	//获取省份配置
	getProvMode: 'api/Common/getProvMode',
	//获取语种列表
	getLanguageList: 'api/Common/getLanguageList',
	//保存用户基础信息 //老高考只传nature_id(1|2)即可 新高考传nature_id(3|4|5) + subject_id
	saveUserInfo: 'api/Common/saveUserInfo',
	//微信小程序支付vip升级
	member_payment: 'api/Vip/member_payment',
	//获取我的志愿单列表
	getVolunteerList: 'api/Exam/getVolunteerList',
	//添加志愿单
	addVolunteerList: 'api/Exam/addVolunteerList',
	//删除志愿单
	deleteVolunteerList: 'api/Exam/deleteVolunteerList',
	//删除志愿单中的志愿
	deleteVolunteerDetail: 'api/Exam/deleteVolunteerDetail',
	//编辑志愿单
	editVolunteerDetail: 'api/Exam/editVolunteerDetail',
	//导出志愿单
	getExcel: 'api/Exam/getExcel',
	//添加志愿方案
	addVolunteerDetail: 'api/Exam/addVolunteerDetail',
	//获取专业详情
	getProfessionDetail: 'api/Profession/getProfessionDetail',
	//卡密激活vip
	cardUpdateVipNew: 'api/Card/cardUpdateVipNew',
	//获取院校详情
	getSchoolDetail: 'api/School/getSchoolDetail',
	//获取学校招生简章列表
	getBrochureList: 'api/School/getBrochureList',
	//文章详情
	getArticleDetail: 'api/Article/getArticleDetail',
	//从院校详情测算录取率
	// getSchoolRatio: 'api/School/getSchoolRatio',
	getSchoolRatio: 'api/School/getSchoolRatioNew',

	//获取一分一段筛选条件
	getScoreRankType: 'api/Tools/getScoreRankType',
	//获取一分一段筛选条件
	getScoreRankList: 'api/Tools/getScoreRankList',
	//隐私协议|用户协议
	getCommonText: 'api/Login/getCommonText',
	//查看志愿单
	// getVolunteerDetail: 'api/Exam/getVolunteerDetail',
	getVolunteerDetail: 'api/Exam/getVolunteerDetailNew',
	//修改志愿单名称
	editVolunteerName: 'api/Exam/editVolunteerName',
	//查看志愿单风险评测
	riskAssessment: 'api/Exam/riskAssessment',
	//获取历史分数列表
	getHistoryList: 'api/School/getHistoryList',
	//获取招生计划列表
	getPlanList: 'api/School/getPlanList',
	//AI机器人网址
	getAiUrl:  'api/HomePage/getAiUrl',
	//获取校考列表
	getSchoolExamScoreList:  'api/SchoolExam/getSchoolExamScoreList',
	//添加我的校考筛选条件
	getSchoolExamSearchList:  'api/SchoolExam/getSchoolExamSearchList',
	//添加校考成绩
	addSchoolExam:  'api/SchoolExam/addSchoolExam',
	//获取我的校考列表
	getMySchoolExamList:  'api/SchoolExam/getMySchoolExamList',
	//修改我的校考
	editMySchoolExamList:  'api/SchoolExam/editMySchoolExamList',
	//删除我的校考
	deleteMySchoolExamList:  'api/SchoolExam/deleteMySchoolExamList',
	//获取校考录取率
	getSchoolExamRatio:  'api/SchoolExam/getSchoolExamRatio',
	//获取计算公式列表
	getLowRealRuleList:  'api/Tools/getLowRealRuleList',
	//获取公式计算结果
	getLowRealRuleRes:  'api/Tools/getLowRealRuleRes',
	//获取艺考考研列表
	getArtPGEE:  'api/Tools/getArtPGEE',
	//测算文化分
	getCultureScore:  'api/Tools/getCultureScore',
	//检查导出状态
	checkExport: 'api/Exam/checkExport',
	//判断是否为子商户
	checkMerchant: 'api/Login/checkMerchant',
	//获取计划年份列表
	getPlanYearLIst: 'api/SchoolExam/getPlanYearLIst',
	// 计算综合分和综合分位次
	getComprehensiveScoreRanking: 'api/Exam/getComprehensiveScoreRanking', 
};

export default api;

